module.exports = __webpack_public_path__ + "static/media/masonary_04.2ce8ace0.png";